export enum WorkspaceMembershipRole {
  guest = 'guest',
  sender = 'sender',
  admin = 'admin',
  owner = 'owner'
}
